<style lang="sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import sass/variables
@import sass/heading
</style>
<script>
function isHeadingLevel (value) {
    return value <= 6 || !value
}

export default {
    name: 'heading',
    props: {
        content: {
            type: String,
            default: ''
        },
        level: {
            type: Number,
            default: 2,
            validator: isHeadingLevel
        },
        levelClass: {
            type: Number,
            default: null,
            validator: isHeadingLevel
        },
        fake: Boolean,
        noMargin: Boolean,
        hidden: Boolean
    },
    render: function (createElement) {
        let el = `h${this.level}`
        let className = `g_${el}`

        // If we have an H1 in hero
        if (this.level === 1) {
            className = `g_h1`
        } else {
            // Overwrte default classe lvl
            if (this.levelClass) {
                className = `g_h${this.levelClass}`
            }
        }

        if (this.noMargin) {
            className += '_nomargin'
        }

        if (this.hidden) {
            className += ` g_visually_hidden`
        }

        if (this.fake) {
            el = 'p'
        }

        return createElement(
            el,
            {
                attrs: {
                    class: className.trim()
                }
            },
            [this.$slots.default, this.content]
        )
    }
}
</script>
